/** Shared browser class contracts backed only by generated experience tokens. */
export const EXPERIENCE_SURFACE_BASE_CLASS = 'experience-candidate-surface-base';

export const EXPERIENCE_SURFACE_SUBTLE_CLASS = 'experience-candidate-surface-subtle';

export const EXPERIENCE_SURFACE_INVERSE_CLASS = 'experience-candidate-surface-inverse';

export const EXPERIENCE_HEADING_CLASS = 'experience-candidate-heading';
export const EXPERIENCE_BODY_CLASS = 'experience-candidate-body';
export const EXPERIENCE_MUTED_CLASS = 'experience-candidate-muted';
export const EXPERIENCE_FOCUS_CLASS = 'experience-candidate-focus';
export const EXPERIENCE_MOTION_CLASS = 'experience-candidate-motion';

export const EXPERIENCE_STATUS_TONE_CLASSES = {
  danger: 'experience-candidate-status',
  warning: 'experience-candidate-status',
  success: 'experience-candidate-status',
  information: 'experience-candidate-status',
  approval: 'experience-candidate-status',
  neutral: 'experience-candidate-status',
} as const;

export type ExperienceStatusTone = keyof typeof EXPERIENCE_STATUS_TONE_CLASSES;
